import React__default from 'react';
import { Typography } from './Typography.mjs';

const SettingsListItem = ({ children, title })=>{
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Typography, {
        variant: "body2",
        color: "secondary",
        component: "dt"
    }, title), /*#__PURE__*/ React__default.createElement("dd", {
        style: {
            margin: '0 0 8px'
        }
    }, children));
};

export { SettingsListItem };
//# sourceMappingURL=SettingsListItem.mjs.map
